module.exports = __webpack_public_path__ + "img/male-default.5c74905b.svg";